export default {
  // Nav
  "nav.home": "Home",
  "nav.woonlening": "Mortgage",
  "nav.loa": "Instalment loans",
  "nav.wieZijnWij": "About us",
  "nav.contact": "Contact",

  // Footer
  "footer.partners": "Partners",
  "footer.simuleer": "Simulate your loan",
  "footer.juridisch": "Legal notices",
  "footer.privacy": "Privacy",
  "footer.hours": "Mon - Fri: 9.00 - 12.30 & 13.30 - 18.00",
  "footer.saturday": "Saturday afternoon by appointment",
  "footer.rights": "MADE BY TEKDAM. ALL RIGHTS RESERVED.",

  // Home - Hero
  "home.hero.title": "",
  "home.hero.body": " - Trusted credit advice since 1995",
  "home.hero.sub1": "For three decades, individuals and professionals have trusted Haskrediet for expert and personalised credit advice.",
  "home.hero.sub1b": "Today, we are ready to realise your plans too.",
  "home.hero.sub2": "Will you be next?",

  // Home - Simuleer
  "home.sim.title": "Simulate your loan",
  "home.sim.subtitle": "Calculate your loan in just a few clicks",
  "home.sim.body": "Discover your financial options today. With Haskrediet's online simulation, you can calculate in seconds how much you can borrow and what your monthly repayment will be. Fast, simple and entirely non-binding. This gives you immediate insight into your budget so you can take the next step well prepared.",
  "home.sim.example": "Example:",
  "home.sim.exLine1": "Instalment loan - You borrow €8,000 over 48 months",
  "home.sim.exLine2": "Monthly payment: €183.86 - Total to repay: €8,825.28",
  "home.sim.jkp": "APR:",
  "home.sim.rente": "Fixed or variable interest rate:",

  // Simulation type toggle
  "sim.type.woon": "Mortgage",
  "sim.type.loa": "Instalment loan",

  // Home - Loan card
  "loan.personalLoan": "Personal loan",
  "loan.amount": "Amount",
  "loan.duration": "Duration (months)",
  "loan.monthly": "Monthly",
  "loan.months": "months",
  "loan.personalCredit": "Personal credit",
  "loan.maxAmount": "The maximum amount is {max}.",
  "loan.totalRepay": "Total to repay",
  "loan.totalInterest": "Total interest",
  "loan.chooseRateHint": "Choose an interest rate to calculate your simulation.",
  "loan.apply": "Apply",
  "loan.onlineApply": "Apply online",

  // Contact form
  "contact.title": "Contact form",
  "contact.firstName": "First name",
  "contact.lastName": "Last name",
  "contact.email": "Email",
  "contact.phone": "Phone number",
  "contact.send": "Send",
  "contact.bubble": "Let's stay in touch",
  "contact.bubbleText": "For more information about our credit solutions, you can leave your details in the form. We will contact you as soon as possible.",
  "contact.message": "Your message:",
  "contact.success": "Your message has been sent successfully!",
  "contact.error": "Something went wrong. Please try again later.",

  // Woonlening
  "woon.title": "MORTGAGE",
  "woon.heroTitle": "Haskrediet - Your reliable partner for mortgages since 1995.",
  "woon.heroBody": "Dreaming of your own home?",
  "woon.heroText": "With over 30 years of experience, Haskrediet guides you to the mortgage that perfectly suits your situation. Independent advice, competitive terms and personal guidance from application to deed.",
  "woon.sim.title": "Simulate your mortgage",
  "woon.sim.subtitle": "Calculate your monthly payment",
  "woon.sim.years": "years",
  "woon.startRequest": "Start your application",
  "woon.desiredAmount": "DESIRED AMOUNT",
  "woon.slogan": "Your dream, our commitment.",
  "woon.val1": "Buying, renovating or refinancing a home? At {brand}, everything starts with listening. We want to understand what truly matters to you: your future, your comfort, your pace...",
  "woon.val2": "We don't believe in standard formulas. Every loan is unique, because every client is too. That's why we work together to find a solution that fits your situation, today and tomorrow.",
  "woon.val3": "Our experts guide you with clear advice, fair conditions and a human approach.",
  "woon.val4": "No empty promises, but clear answers and genuine commitment.",
  "woon.cta": "With {brand}, you make choices with confidence: step by step, at your own pace.",

  // Leningen
  "len.title": "INSTALMENT LOANS",
  "len.heroLine1": "Your plans deserve tailored financing.",
  "len.heroText1": "Whether it's a new car, a renovation, a dream trip or unexpected expenses: with us, you quickly have the financial room you need. We review your situation together and find a solution that perfectly matches your budget and future plans. Transparent, personal and without surprises.",
  "len.heroTagline": "Quickly arranged. Clear terms. Personal guidance.",
  "len.whatCanWeDo": "What can we do for you?",
  "len.personal": "Personal loan",
  "len.personalDesc": "A personal project, a major purchase or an unexpected expense? With a personal loan from Haskrediet, you realise your plans without worry.",
  "len.auto": "Car loan",
  "len.autoDesc": "Looking for a new or second-hand car? With our car loan, you drive away quickly and affordably. Competitive financing at your pace.",
  "len.reno": "Renovation loan",
  "len.renoDesc": "Renovating or making your home more sustainable? Our renovation loan gives your home a second life - tailored to your budget.",
  "len.regroup": "Credit consolidation",
  "len.regroupDesc": "Multiple running loans? We bundle them into one clear monthly payment - often more affordable, always clearer.",
  "len.chooseProject": "Choose your project",
  "len.desiredAmount": "Desired amount",
  "len.paymentCount": "Desired number of payments?",
  "len.clickHere": "Click here",
  "len.dur": "Duration",
  "len.totalBack": "Total to repay:",

  // Broker info
  "home.broker.title": "Why choose Haskrediet?",
  "home.broker.intro1": "Since 1995, Haskrediet has been guiding clients in finding the right credit solution. With over 30 years of experience, we have built a strong reputation as a reliable and professional credit broker.",
  "home.broker.intro2": "",
  "home.broker.troeven": "Our strengths",
  "home.broker.ervaring.title": "Extensive experience and expertise",
  "home.broker.ervaring.text": "Since 1995, we have closely followed the credit market. This allows us to expertly advise and guide our clients through important financial decisions.",
  "home.broker.persoonlijk.title": "Personal approach",
  "home.broker.persoonlijk.text": "We listen to your needs, analyse your situation and find a solution that perfectly matches your requirements.",
  "home.broker.onafhankelijk.title": "Independent advice",
  "home.broker.onafhankelijk.text": "As a credit broker, we compare different lenders. This way, we help you find a formula with conditions that best suit your profile.",
  "home.broker.begeleiding.title": "Complete guidance",
  "home.broker.begeleiding.text": "From the initial application to the final processing of your file, we stand by your side. You can count on clear communication and professional support throughout the entire process.",
  "home.broker.vertrouwen.title": "Trust and transparency",
  "home.broker.vertrouwen.text": "For over three decades, clients have chosen Haskrediet for our honest approach, transparent information and reliable service.",
  "home.broker.aanbod.title": "Wide range",
  "home.broker.aanbod.text": "From mortgages and personal loans to leasing and business loans: at Haskrediet, you will find all financing solutions under one roof.",
  "home.broker.closing.title": "Over 30 years of experience to your advantage",
  "home.broker.closing.text": "At Haskrediet, we believe that good credit advice starts with listening to the client. That is why we commit every day to offering tailored financial solutions, supported by experience, expertise and personal service.",
  "home.broker.closing.tagline": "Haskrediet - your trusted credit partner since 1995.",

  // Simulation info
  "home.sim.free": "Start your free simulation - this is entirely non-binding and without obligation.",

  // Loan calculator
  "loan.rate": "Annual interest rate (%)",
  "loan.amountInfo.woon": "The desired amount for a mortgage is between €25,000 and €3,000,000.",
  "loan.amountInfo.loa": "The desired amount for an instalment loan is between €500 and €99,999.99.",
  "loan.durationInfo.woon": "The duration for a mortgage is between 5 and 30 years.",
  "loan.durationInfo.loa": "The duration depends on the borrowed amount:",
  "loan.durationTable.amount": "Amount",
  "loan.durationTable.maxDuration": "Max. duration",
  "loan.durationTable.above": "Above",
  "loan.rateInfo": "You choose the interest rate here for your simulation. This is not the final rate. The actual percentage depends on various factors and will be determined after personal advice from HASKREDIET.",

  // Footer
  "footer.maps": "DIRECTIONS",

  // Verzekeringen
  "nav.verzekeringen": "Insurance",
  "verz.title": "INSURANCE",
  "verz.intro": "In addition to credit solutions, we also offer a comprehensive range of insurance products. Discover our full offering on our insurance page.",
  "verz.link": "Go to Haskrediet Insurance",

  // Leasing
  "nav.leasing": "Leasing",
  "leasing.title": "LEASING APPLICATION",
  "leasing.heroTitle": "Invest today, pay in instalments",
  "leasing.heroText": "Want to finance a car, van, machine or professional equipment without using your available capital? With leasing through Haskrediet, you benefit from a flexible and tax-efficient solution, fully tailored to your business.",
  "leasing.whyTitle": "Why choose leasing through Haskrediet?",
  "leasing.why1": "Fast and personal handling of your file",
  "leasing.why2": "Financing tailored to your business",
  "leasing.why3": "Preservation of your working capital and financial headroom",
  "leasing.why4": "Option to purchase at the end of the contract",
  "leasing.why5": "Transparent terms, without surprises",
  "leasing.why6": "Over 30 years of experience in financial solutions",
  "leasing.whatTitle": "For which investments?",
  "leasing.whatIntro": "We guide you with the leasing of:",
  "leasing.what1": "Passenger cars and company vehicles",
  "leasing.what2": "Vans and trucks",
  "leasing.what3": "Machines and production equipment",
  "leasing.what4": "Construction and agricultural equipment",
  "leasing.what5": "IT and office equipment",
  "leasing.what6": "Medical and professional equipment",
  "leasing.customTitle": "A solution tailored to your activity",
  "leasing.customText": "Every business is unique. That is why we look together at which leasing formula best suits your needs, your budget and your growth plans.",
  "leasing.customTagline": "Fast, expert and personally guided.",
  "leasing.ctaTitle": "Request your leasing without obligation",
  "leasing.ctaText": "Want to know what options are available for your investment? Our specialists are ready to advise you and work out a tailored proposal.",
  "leasing.ctaClosing": "Request your leasing today and realise your professional plans with confidence.",
  "leasing.ctaTagline": "Haskrediet - Your reliable financing partner since 1995.",
  "leasing.contactBtn": "Contact us",
  "leasing.formSubject": "New leasing application - Haskrediet",

  // Ondernemers
  "nav.ondernemers": "Entrepreneurs",
  "ond.title": "BUSINESS & INVESTMENT LOANS",
  "ond.heroTitle": "Give your business room to grow",
  "ond.heroText1": "Want to invest in the future of your business? With a business loan or investment loan through Haskrediet, you have the financial resources to realise your plans without jeopardising your liquidity.",
  "ond.heroText2": "Whether you are starting, expanding or modernising, we guide you with a financing solution that matches your business ambitions.",
  "ond.whatTitle": "What can you use an investment loan for?",
  "ond.what1": "Purchase or renovation of business premises",
  "ond.what2": "Machines and production equipment",
  "ond.what3": "Vehicles and company cars",
  "ond.what4": "IT infrastructure and digitalisation",
  "ond.what5": "Expansion of your activities",
  "ond.what6": "Acquisition of a business",
  "ond.what7": "Financing of professional equipment",
  "ond.what8": "Strengthening of your working capital",
  "ond.whyTitle": "Why choose Haskrediet?",
  "ond.adv1.title": "Personalised advice",
  "ond.adv1.text": "Every business is unique. That is why we work together to find the financing solution that fits your activity and future plans.",
  "ond.adv2.title": "Over 30 years of experience",
  "ond.adv2.text": "Since 1995, we have been guiding self-employed professionals, SMEs and entrepreneurs with expert and independent advice.",
  "ond.adv3.title": "Fast and efficient handling",
  "ond.adv3.text": "We carefully analyse your file and ensure smooth follow-up, so you can focus on your business.",
  "ond.adv4.title": "Transparent terms",
  "ond.adv4.text": "Clear agreements and financing that matches your possibilities and objectives.",
  "ond.closingTitle": "Invest with confidence. Grow with certainty.",
  "ond.closingText": "A strong business deserves a strong financial partner. Haskrediet helps you realise your investment projects with professional advice and tailored solutions.",
  "ond.closingCta": "Request your business or investment loan today without obligation.",
  "ond.closingTagline": "Haskrediet - The reliable partner for entrepreneurs and self-employed professionals for over 30 years.",
  "ond.contactBtn": "Contact us",
  "ond.formSubject": "New business loan application - Haskrediet",

  // Wie zijn wij
  "wie.title": "ABOUT US",
  "wie.heroIntro1": "As a credit broker, we guide individuals and entrepreneurs in finding the most suitable financing solution. Thanks to our independent position, we compare different lenders and look for a formula that matches your financial situation, wishes and future plans.",
  "wie.heroIntro2": "We believe that a credit is more than just a loan. It is an important financial decision that requires expert advice, transparency and personal guidance. That is why we take the time to thoroughly analyse your file and clearly explain all the options.",
  "wie.heroIntro3": "Whether it concerns a mortgage, refinancing, investment credit or another financing need, we support you throughout the entire process: from the first simulation to the final signing.",
  "wie.values.title": "Our core values:",
  "wie.values.onafhankelijk": "Independent advice: we compare different providers to find the best solution for you.",
  "wie.values.begeleiding": "Personal guidance: every client and every file is unique.",
  "wie.values.transparantie": "Transparency: clear communication without surprises.",
  "wie.values.deskundigheid": "Expertise: up-to-date knowledge of the credit market and financial regulations.",
  "wie.closing1": "As a credit broker, we strive to make financing accessible, understandable and worry-free. This way, you can make the right financial choices with confidence.",
  "wie.closing2": "Credit Broker - your reliable partner for tailored credit advice.",

  // Juridische mededeling
  "jur.title": "LEGAL NOTICES",
  "jur.companyTitle": "Company details",
  "jur.btwLabel": "VAT",
  "jur.activityTitle": "Activity",
  "jur.activityText": "HASKREDIET BV operates as an intermediary in mortgage and consumer credit. We act as a credit broker and compare offers from various lenders to find the most suitable financing solution for our clients.",
  "jur.fsmaTitle": "Supervisory authority",
  "jur.fsmaText": "HASKREDIET BV is registered as an intermediary in mortgage and consumer credit with the FSMA (Financial Services and Markets Authority), Rue du Congrès 12-14, 1000 Brussels.",
  "jur.fsmaCheck": "You can verify our registration on the FSMA website: www.fsma.be.",
  "jur.disclaimerTitle": "Disclaimer",
  "jur.disclaimerText1": "The information on this website is purely informational and does not constitute a credit offer. Each credit application is assessed individually and is subject to approval by the lender.",
  "jur.disclaimerText2": "The simulations on this website are indicative and non-binding. Actual conditions may differ after analysis of your personal situation.",
  "jur.liabilityTitle": "Liability",
  "jur.liabilityText1": "HASKREDIET BV takes the greatest care with the content of this website but cannot guarantee the completeness, accuracy or timeliness of the information provided.",
  "jur.liabilityText2": "HASKREDIET BV cannot be held liable for any damage resulting from the use of this website or the information presented on it.",
  "jur.ipTitle": "Intellectual property",
  "jur.ipText": "All texts, images, logos and other elements on this website are protected by copyright and may not be reproduced, distributed or used without the prior written consent of HASKREDIET BV.",
  "jur.disputeTitle": "Disputes",
  "jur.disputeText": "These legal notices and the use of this website are governed by Belgian law. Any disputes fall under the exclusive jurisdiction of the courts of Ghent.",

  // Privacy
  "priv.title": "PRIVACY POLICY",
  "priv.intro": "HASKREDIET BV attaches great importance to the protection of your personal data. This privacy policy explains what data we collect, why we do so and how we protect your privacy, in accordance with the General Data Protection Regulation (GDPR).",
  "priv.controllerTitle": "Data controller",
  "priv.dataTitle": "What data do we collect?",
  "priv.dataText": "We may collect the following personal data when you contact us or submit a request:",
  "priv.data1": "First and last name",
  "priv.data2": "Email address",
  "priv.data3": "Phone number",
  "priv.data4": "Messages sent via the contact form",
  "priv.purposeTitle": "What do we use your data for?",
  "priv.purposeText": "Your personal data is used exclusively for the following purposes:",
  "priv.purpose1": "Responding to your questions and requests",
  "priv.purpose2": "Providing advice on credit and financing solutions",
  "priv.purpose3": "Following up on your file",
  "priv.legalTitle": "Legal basis",
  "priv.legalText": "The processing of your personal data is based on your consent (when filling in the contact form) and on the performance of a contract or pre-contractual measures.",
  "priv.retentionTitle": "Retention period",
  "priv.retentionText": "Your personal data is not kept longer than necessary for the purposes for which it was collected, unless a longer retention period is required by law.",
  "priv.sharingTitle": "Data sharing",
  "priv.sharingText": "We do not share your personal data with third parties unless this is necessary for the performance of our services (for example with a lender for a credit application) or when we are legally obliged to do so.",
  "priv.rightsTitle": "Your rights",
  "priv.rightsText": "You have the right at any time to:",
  "priv.right1": "Access your personal data",
  "priv.right2": "Have your data corrected or supplemented",
  "priv.right3": "Have your data deleted",
  "priv.right4": "Restrict the processing of your data",
  "priv.right5": "Object to the processing of your data",
  "priv.rightsContact": "You can exercise your rights by contacting us at info@haskrediet.be or 09/267.30.30.",
  "priv.cookieTitle": "Cookies",
  "priv.cookieText": "This website may use cookies to improve the user experience. By continuing to use the website, you consent to the use of cookies.",
  "priv.changeTitle": "Changes",
  "priv.changeText": "HASKREDIET BV reserves the right to modify this privacy policy at any time. The most recent version is always available on this page.",

  // Disclaimer
  "loan.disclaimer": "Loan subject to file acceptance",

  // Global
  "global.loanCost": "Please note, borrowing money costs money too.",
} as Record<string, string>;
